export const skuOrdersKeys = {
  all: ['partnerOrders'],
  list: (venueId, tab) => [...skuOrdersKeys.all, venueId, tab],
};
